import {createFileRoute} from '@tanstack/react-router';

import {SettingsSearchParams} from '~utils/routeUtil';

import {BaseLayout} from '~components/_layout/BaseLayout';
import {ProjectSettings} from '~components/settings/ProjectSettings';
import {ProjectSettingsTabs} from '~components/settings/ProjectSettingsTab';

export const Route = createFileRoute('/settings/adminConfig')({
  component: SettingsAdminConfigPage,
  validateSearch: SettingsSearchParams.validate,
});

function SettingsAdminConfigPage(): JSX.Element {
  return (
    <BaseLayout>
      <ProjectSettings tabName={ProjectSettingsTabs.Admin} />
    </BaseLayout>
  );
}
